/**
 * Created by pmacko on 30.10.2016.
 */

/// <reference path="jquery/jquery.d.ts" />
/// <reference path="summernote/summernote.d.ts" />

$(document).ready(function() {
    $('.summernote').summernote({
        onCreateLink : function(originalLink:string) {
            return originalLink; // return original link
        }
    });
});